import ContentCopy from "@mui/icons-material/ContentCopy";
import { IconButton, Tooltip } from "@mui/material";
import { useCopyDialogs } from "./use-copy-dialogs";

import type { UUID } from "../../../../utils/uuid";
import type { FC } from "react";

export const CopyAction: FC<{
  id: UUID;
  title: string | null;
  clonable: boolean | "warn_first";
  disabled?: { reason: string };
}> = ({ id, title, clonable, disabled }) => {
  const { handleCopy, dialogControl, CopyDialogComponent } = useCopyDialogs({ clonable });

  return (
    <>
      <Tooltip title={disabled ? disabled.reason : `Copy Communication: ${title}`}>
        <span>
          <IconButton
            data-analytics-id="moment-card-copy"
            onClick={handleCopy}
            disabled={Boolean(disabled)}
          >
            <ContentCopy fontSize="small" sx={{ marginLeft: 0 }} data-testid="moment-copy-icon" />
          </IconButton>
        </span>
      </Tooltip>
      {CopyDialogComponent && (
        <CopyDialogComponent
          id={id}
          title={title}
          open={dialogControl.open}
          onClose={dialogControl.handleClose}
        />
      )}
    </>
  );
};
